export const TOGGLE_MENU = "TOGGLE_MENU";
export const TOGGLE_RESOURCES_STATS = "TOGGLE_RESOURCES_STATS";
export const OPEN_TOOLTIP = "OPEN_TOOLTIP";
export const CLOSE_TOOLTIP = "CLOSE_TOOLTIP";
export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export const OPEN_CITY_DIALOG = "OPEN_CITY_DIALOG";
export const CLOSE_CITY_DIALOG = "CLOSE_CITY_DIALOG";
export const OPEN_CONTENT_POPUP = "OPEN_CONTENT_POPUP";
export const CLOSE_CONTENT_POPUP = "CLOSE_CONTENT_POPUP";
export const CLOSE_DIALOGS = "CLOSE_DIALOGS";
export const TOGGLE_IDLE_STATE = "TOGGLE_IDLE_STATE";
export const SET_ERROR = "SET_ERROR";
export const GET_TYPEHINT = "GET_TYPEHINT";
export const SET_TYPEHINT = "SET_TYPEHINT";
export const CHECK_DUPLICITY = "CHECK_DUPLICITY";
export const SET_NOTIFICATION_READ = "SET_NOTIFICATION_READ";
export const SET_NOTIFICATION_SEEN = "SET_NOTIFICATION_SEEN";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const UPDATE_NOTIFICATIONS_SEEN = "UPDATE_NOTIFICATIONS_SEEN";
export const UPDATE_CREDITS = "UPDATE_CREDITS";

export const INIT_STATE = "INIT_STATE";
export const SET_STATE = "SET_STATE";
export const UPDATE_STATE = "UPDATE_STATE";
export const UPDATE_POPULATION = "UPDATE_POPULATION";
export const UPDATE_DEVELOPMENT = "UPDATE_DEVELOPMENT";
export const UPDATE_RESOURCES = "UPDATE_RESOURCES";
export const UPDATE_GENERAL = "UPDATE_GENERALS";
export const UPDATE_GENERALS = "UPDATE_GENERALS";
export const ADD_TILE = "ADD_TILE";
export const UPDATE_SLOT = "UPDATE_SLOT";
export const PURCHASE_TILE = "PURCHASE_TILE";
export const EXPAND_TILE = "EXPAND_TYPE";
export const HIRE_POP = "HIRE_POP";
export const RELEASE_POP = "RELEASE_POP";
export const BUILD_BUILDING = "BUILD_BUILDING";
export const UPGRADE_BUILDING = "UPGRADE_BUILDING";
export const DEMOLISH_BUILDING = "DEMOLISH_BUILDING";
export const CANCEL_BUILDING_DEMOLITION = "CANCEL_BUILDING_DEMOLITION";
export const REPAIR_BUILDING = "REPAIR_BUILDING";
export const NEXT_TURN = "NEXT_TURN";
export const QUEST_LIST_VIEWED = "QUEST_LIST_VIEWED";
export const FINISH_QUEST = "FINISH_QUEST";
export const BOOST_HAPPINESS = "BOOST_HAPPINESS";

export const LEAVE_ALLIANCE = "LEAVE_ALLIANCE";
export const FOUND_ALLIANCE = "FOUND_ALLIANCE";
export const APPLY_ALLIANCE = "APPLY_ALLIANCE";
export const CANCEL_APPLICATION = "CANCEL_APPLICATION";
export const ACCEPT_APPLICATION = "ACCEPT_APPLICATION";
export const EXPEL_MEMBER = "EXPEL_MEMBER";
export const TOGGLE_WAR_APPLICATION = "TOGGLE_WAR_APPLICATION";
export const EDIT_NOTE = "EDIT_NOTE";
export const ABDICATE = "ABDICATE";
export const TOGGLE_COMMANDER = "TOGGLE_COMMANDER";
export const HANDOVER_EMPEROR = "HANDOVER_EMPEROR";

export const INVEST_TECH_POINT = "INVEST_TECH_POINT";

export const INVEST_SKILL_POINT = "INVEST_SKILL_POINT";
export const INVEST_TECH_POINT_XP = "INVEST_TECH_POINT_XP";
export const INVEST_STRENGTH_BONUS = "INVEST_STRENGTH_BONUS";

export const CHOOSE_TREASURE = "CHOOSE_TREASURE";

export const SELL_ITEM = "SELL_ITEM";
export const CANCEL_MARKET_ITEM = "CANCEL_MARKET_ITEM";
export const BUY_ITEM = "BUY_ITEM";

export const RECRUIT_UNIT = "RECRUIT_UNIT";
export const RELEASE_UNIT = "RELEASE_UNIT";
export const OCCUPY_BANNER = "OCCUPY_BANNER";
export const LEAVE_BANNER = "LEAVE_BANNER";
export const ADD_BANNER_UNITS = "ADD_BANNER_UNITS";
export const REMOVE_BANNER_UNITS = "REMOVE_BANNER_UNITS";
export const ASSIGN_BANNER_GENERAL = "ASSIGN_BANNER_GENERAL";
export const RELEASE_BANNER_GENERAL = "RELEASE_BANNER_GENERAL";
export const SET_BATTLE_TACTICS = "SET_BATTLE_TACTICS";

export const INVEST_MAGIC_RESEARCH = "INVEST_MAGIC_RESEARCH";
export const LEARN_SPELL = "LEARN_SPELL";
export const UPGRADE_SPELL = "UPGRADE_SPELL";
export const DISPERSE_SPELL = "DISPERSE_SPELL";
export const CAST_SPELL = "CAST_SPELL";
export const PLAN_SPELL = "PLAN_SPELL";
export const UPDATE_SPELL = "UPDATE_SPELL";
export const TOGGLE_MAGIC_PLAN = "TOGGLE_MAGIC_PLAN";
export const SET_MAGIC_MODE = "SET_MAGIC_MODE";
export const SET_AUTOCAST = "SET_AUTOCAST";

export const PURCHASE_TOOL = "PURCHASE_TOOL";

export const GET_NEWS = "GET_NEWS";
export const MOVE_CALENDAR = "MOVE_CALENDAR";
export const UPDATE_NEWS = "UPDATE_NEWS";

export const SEND_THIEVES = "SEND_THIEVES";
export const CANCEL_THIEVES = "CANCEL_THIEVES";

export const GET_CHAT_POSTS = "GET_CHAT_POSTS";
export const SEND_CHAT_POST = "SEND_CHAT_POST";
export const DELETE_CHAT_POSTS = "DELETE_CHAT_POSTS";

export const GET_MAIL_POSTS = "GET_MAIL_POSTS";
export const SEND_MAIL_POST = "SEND_MAIL_POST";
export const DELETE_MAIL_POSTS = "DELETE_MAIL_POSTS";

export const EMP_TENT_INIT_STATE = "EMP_TENT_INIT_STATE";
export const EMP_TENT_SET_CHANGED = "EMP_TENT_SET_CHANGED";
export const EMP_TENT_UPDATE_MEMBER = "EMP_TENT_UPDATE_MEMBER";
